import { render, staticRenderFns } from "./oll-figure.vue?vue&type=template&id=1f08d664&"
import script from "./oll-figure.vue?vue&type=script&lang=js&"
export * from "./oll-figure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports